<template>
  <Layout title="Help and Advice">
    <div class="page">
      <div class="hero">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12">
              <h1 class="text-center">Help &amp; Advice</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <p>
              We believe contracts should be simple to execute. Hear from our
              founder on how Clausify enables this.
            </p>
          </div>
        </div>
        <div class="row justify-content-center mb-5">
          <div class="col-lg-8">
            <TutorialVideo />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import TutorialVideo from '@/Shared/TutorialVideo';

export default {
  components: {
    Layout,
    TutorialVideo,
  },
};
</script>
